import React from 'react';
import Card from './card';

const Welcome = (props) => {
  if (props.model.getIn(['loan', 'loanState'])) {
    return (
      <Card
        title="Let’s dive into a few more details to complete your profile. We’ve pre-filled all the answers you’ve given us so far, so you won’t need to answer those questions again."
        {...props}
      />
    );
  } else {
    return (
      <Card
        title="In order to find you a great rate we need to ask you some questions. This should take less than 4 minutes."
        {...props}
      />
    );
  }
};
Welcome.id = 'FullWelcome';
Welcome.completed = ({ model }) => model.getIn(['loan', 'termsAgree']);
export default Welcome;



// WEBPACK FOOTER //
// ./src/cards/welcome/full.js